import { Button } from "@fluentui/react-components";
import { ArrowDownload24Regular } from "@fluentui/react-icons";
import React from "react";
import styles from "./ConversationExporterButton.module.css";

interface Props {
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isInside: boolean;
}

export const ConversationExporterButton = ({ className, style, disabled, onClick, onMouseEnter, onMouseLeave, isInside }: Props) => {
  const iconColor = isInside ? "#002664" : "#6c757d";

  return (
    <div className={styles.button} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {/* Icon-only: the header row is capped at the chat column's 847px and
          must fit four buttons. The label survives as tooltip + a11y name. */}
      <Button
        onClick={onClick}
        disabled={disabled}
        appearance="subtle"
        className={`${styles.container} ${className ?? ""}`}
        style={style}
        aria-label="Download Conversations"
        title="Download Conversations"
      >
        <div className={styles.downloadIcon}>
          <ArrowDownload24Regular color={iconColor} />
        </div>
      </Button>
    </div>
  );
};
